import type { BookingDraft } from "./bookingDraft";
import type { View } from "./types";

type TranslateFn = (key: string, defaultValue: string, options?: Record<string, unknown>) => string;

/**
 * Decides the sticky CTA label and destination for the Specialist/Services list views.
 * Follows the rules from .clinerules/booking-widget-flow.md
 */
export function useStepCta(
  draft: BookingDraft,
  current: "specialist" | "services",
  t: TranslateFn,
): { label: string; go: View } | null {
  const hasSpecialist = !!draft.specialistId;
  const hasServices = (draft.serviceIds ?? []).length > 0;

  if (hasSpecialist && hasServices) {
    return { label: t("widget.datetime.choose", "Choose date & time"), go: "datetime" };
  }
  if (current === "specialist" && hasSpecialist && !hasServices) {
    return { label: t("widget.services.choose", "Choose service"), go: "services" };
  }
  if (current === "services" && hasServices && !hasSpecialist) {
    return { label: t("widget.specialists.choose", "Choose specialist"), go: "specialist" };
  }
  return null;
}
